import { ProjectList } from "./ProjectList";
import { ProjectShow } from "./ProjectShow";

// Téléphone : la fiche en page entière.
export default {
  list: ProjectList,
  show: ProjectShow,
};

// Ordinateur : la liste reçoit aussi /projects/:id/show et y ouvre la fiche en panneau.
export const desktopProjects = {
  list: ProjectList,
  hasShow: true,
};
